import { SchemaDescription } from 'yup';

import useFastFormProviderContext from './useFastFormProviderContext';

function useFormValidationDescription(): SchemaDescription {
  const context = useFastFormProviderContext();
  return context.validationDescription;
}

export default useFormValidationDescription;
